import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";

const Meals = ({ prevStep, nextStep }) => {
  const rules = [
    "Meals are discussed with you in the weekly meeting for the food shop to be planned and completed",
    "Breakfast time is between 08:00-09:00",
    "Lunch time is 12:00-13:00",
    "Dinner time is 16:00-17:00",
    "Share with staff if there is a change to the menu you would like",
    "Snacks are available and chosen by you in the weekly meeting to plan for the food shop",
    "There should be choices of healthy foods",
    "Making food fresh is our preferred option for you",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />
        <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
          House Rules
        </Typography>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Meals
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Share your meal preferences during weekly meetings and participate in a healthy, balanced eating routine."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "14px", color: "black" }}>
                    {rule.split(/(\d{2}:\d{2}-\d{2}:\d{2})/).map((part, i) =>
                      /\d{2}:\d{2}-\d{2}:\d{2}/.test(part) ? (
                        <span key={i} style={{ fontWeight: 700 }}>
                          {part}
                        </span>
                      ) : (
                        part
                      )
                    )}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
      <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={1} mr={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Meals;
